import { State } from "common/types/redux";

import TagsFeature from "seneca-common/features/course-discovery/tags-feature/state/models/TagsFeature";
import {
  AllowedCallTypes,
  CrudConfig,
  makeApiStatesSelectorsFactory
} from "seneca-common/utils/apiStates";

import { PATH_TAGS_FEATURE, tagsCrudConfig } from "../consts";

function getTagsFeatureSlice(state: any): TagsFeature {
  return state.get(PATH_TAGS_FEATURE);
}

function getSelectorNamesForCallType(tagsStateSelectors: any, callType: any) {
  const {
    hasStarted,
    didSucceed,
    didError,
    getLastFetchedTime,
    hasFinished,
    notSucceededOrStarted
  } = tagsStateSelectors[callType];

  if (callType === AllowedCallTypes.FETCH_ALL) {
    return {
      getFetchTagsStarted: hasStarted,
      getFetchTagsSuccess: didSucceed,
      getFetchTagsError: didError,
      getFetchTagsLastFetched: getLastFetchedTime,
      tagsHaveFinishedFetching: hasFinished,
      tagsNeedFetching: notSucceededOrStarted
    };
  } else if (AllowedCallTypes.CREATE) {
    return {
      tagIsCreating: hasStarted,
      tagCreateSucceeded: didSucceed,
      tagCreateErrored: didError,
      tagCreateHasFinished: hasFinished
    };
  } else if (AllowedCallTypes.UPDATE) {
    return {
      tagIsUpdating: hasStarted,
      tagUpdateSucceeded: didSucceed,
      tagUpdateErrored: didError,
      tagUpdateHasFinished: hasFinished
    };
  } else if (AllowedCallTypes.DELETE) {
    return {
      tagIsDeleting: hasStarted,
      tagDeleteSucceeded: didSucceed,
      tagDeleteErrored: didError,
      tagDeleteHasFinished: hasFinished
    };
  }

  throw new Error("Not allowed call type specified" + callType);
}

export function makeSelectors(
  getStateSlice: (arg0: any) => TagsFeature,
  crudStateConfig: CrudConfig
): any {
  const getTagsMetaSlice = (state: State) => getStateSlice(state).get("meta");

  const makeTagsStatesSelectors =
    makeApiStatesSelectorsFactory(crudStateConfig);

  // @ts-ignore
  const tagsStateSelectors = makeTagsStatesSelectors(getTagsMetaSlice);

  // @ts-ignore
  return crudStateConfig.callTypes.reduce((acc, callType) => {
    return {
      ...acc,
      ...getSelectorNamesForCallType(tagsStateSelectors, callType)
    };
  }, {});
}

export const {
  getFetchTagsStarted,
  getFetchTagsSuccess,
  getFetchTagsError,
  getFetchTagsLastFetched,
  tagsHaveFinishedFetching,
  tagsNeedFetching,
  tagIsCreating,
  tagCreateSucceeded,
  tagCreateErrored,
  tagCreateHasFinished,
  tagIsUpdating,
  tagUpdateSucceeded,
  tagUpdateErrored,
  tagUpdateHasFinished,
  tagIsDeleting,
  tagDeleteSucceeded,
  tagDeleteErrored,
  tagDeleteHasFinished
} = makeSelectors(getTagsFeatureSlice, tagsCrudConfig);
